import { CONSENT_STORAGE_KEY, DEFAULT_CONSENT_PREFERENCES } from "../constants";
import { ConsentPreferences, StoredConsent } from "../types";

const FULL_STORAGE_KEY = `wingspan:${CONSENT_STORAGE_KEY}`;

const isStoredConsent = (value: unknown): value is StoredConsent =>
  typeof value === "object" &&
  value !== null &&
  "version" in value &&
  "preferences" in value &&
  (value as StoredConsent).version === 1;

export const readStoredConsent = (): StoredConsent | undefined => {
  try {
    const raw = localStorage.getItem(FULL_STORAGE_KEY);
    if (!raw) return undefined;
    const parsed: unknown = JSON.parse(raw);
    return isStoredConsent(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const getCurrentPreferences = (): ConsentPreferences =>
  readStoredConsent()?.preferences ?? DEFAULT_CONSENT_PREFERENCES;
